import React from "react";
import { create } from "zustand";
import DataListStore from "../../store/DataListStore";
import ListViewV2 from "../App/DataListV2";
import { UpdateStatusPesanan } from "services/datalist/datalist-api";
import { Button, notification, Space } from "antd";

import { CloseCircleOutlined } from "@ant-design/icons";

const defaultDataStore = create(DataListStore);

const ListOngkirManual = () => {
  let user = localStorage.getItem("auth-id");
  const userObj = JSON.parse(user);

  return (
    <ListViewV2
      viewId={"ongkirmanual"}
      store={defaultDataStore}
      customRowAction={(props) => (
        <Space style={{ display: "flex", justifyContent: "left" }}>
          <Button
            title="CANCEL ONGKIR"
            danger
            onClick={async () => {
              if (window.confirm("Batalkan konfirmasi pembayaran ongkir ?")) {
                var data = {
                  sesionId: props.data.SesionID,
                  sequence: props.data.No,
                  user: userObj.firstName,
                  action: "CANCEL ONGKIR",
                };
                const { affect } = await UpdateStatusPesanan(data);

                if (affect && affect > 0) {
                  notification.success({
                    message: "Update Status Pesanan",
                    description: "Status pesanan berhasil di update",
                  });
                } else {
                  notification.error({
                    message: "Update Status Pesanan",
                    description:
                      "Status pesanan gagal diupdate. Coba lagi nanti",
                  });
                }
              }
            }}
          >
            <Space>
              <CloseCircleOutlined />
            </Space>
          </Button>
        </Space>
      )}
      hideEdit
    />
  );
};

export default ListOngkirManual;
